import { InsuranceDto } from '@maia/shared';
import { cardStyles, SectionWithHeader, SpecList } from '@maia/ui';
import { twMerge } from 'tailwind-merge';

type Props = {
  insurance: InsuranceDto;
};

export function InsuranceInformationCard(props: Props) {
  const { insurance } = props;

  return (
    <SectionWithHeader title="Gegevens van de verzekering">
      <div className={twMerge(cardStyles({ variant: 'outlined' }), 'p-20')}>
        <SpecList
          items={insurance.specs
            .filter((spec) => spec.value)
            .map((spec) => ({
              icon: spec.icon,
              title: spec.label,
              value: spec.value,
              isHalf: true,
            }))}
        />
      </div>
    </SectionWithHeader>
  );
}
